<template>
  <Modal
    :open="show"
    @closed="$emit('close')"
  >
    <div class="modal-header border-0">
      <h5 class="modal-title m-0 d-flex align-items-center">
        Reject Leave Request
      </h5>
      <button @click="$emit('close')" type="button" class="btn-close outline-none" data-dismiss="modal" aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <label for="rejection_reason" class="form-label">Reason for Rejection <span class="text-danger">*</span></label>
          <textarea 
            class="form-control" 
            id="rejection_reason" 
            v-model="rejectionReason" 
            rows="3" 
            required
            :disabled="loading"
          ></textarea>
        </div>
        <div class="d-flex justify-content-end">
          <button 
            type="button" 
            class="btn btn-outline-secondary me-2" 
            @click="$emit('close')"
            :disabled="loading"
          >
            Cancel
          </button>
          <button 
            type="submit" 
            class="btn btn-danger" 
            :disabled="loading || !rejectionReason.trim()"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Reject
          </button>
        </div>
      </form>
    </div>
  </Modal>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'RejectLeaveRequestModal',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'reject'],
  setup(props, { emit }) {
    const rejectionReason = ref('');

    const handleSubmit = () => {
      if (!rejectionReason.value.trim()) return;
      emit('reject', rejectionReason.value.trim());
      rejectionReason.value = '';
    };

    return {
      rejectionReason,
      handleSubmit
    };
  }
};
</script>
